import { estimateMutationScopeId } from '@/api/mutations/estimates/hydrateEstimateCaches';
import useAddEstimateGrant from '@/api/mutations/estimates/useAddEstimateGrant';
import useRemoveEstimateGrant from '@/api/mutations/estimates/useRemoveEstimateGrant';
import useGetProjectEstimate from '@/api/queries/project/useGetProjectEstimate';
import GrantsPicker from '@/ui/components/estimatesAndProposals/grantOption/GrantsPicker';
import { FC } from 'react';

type GrantsTabProps = {
  projectId: string;
  estimateId: string;
};

const GrantsTab: FC<GrantsTabProps> = (props) => {
  const { projectId, estimateId } = props;
  const { estimate } = useGetProjectEstimate(projectId, estimateId);

  const mutationOptions = {
    scope: { id: estimateMutationScopeId(estimateId) },
  };
  const addEstimateGrant = useAddEstimateGrant({
    projectId,
    estimateId,
    options: mutationOptions,
  });
  const removeEstimateGrant = useRemoveEstimateGrant({
    projectId,
    estimateId,
    options: mutationOptions,
  });

  if (!estimate) return null;

  return (
    <GrantsPicker
      attached={estimate.grants}
      mutationScopeId={estimateMutationScopeId(estimateId)}
      onAdd={({ catalogueGrantId, grantLineId }) =>
        addEstimateGrant.mutate({
          estimateId,
          accountGrantId: catalogueGrantId,
          publicId: grantLineId,
        })
      }
      onRemove={(id) => removeEstimateGrant.mutate({ id })}
    />
  );
};

export default GrantsTab;
